import { INPUT_MSG } from "@/consts/message";
import { useNavigate } from "react-router-dom";
import * as ViewModel from "@/core/presenter/viewModel";

interface IProps {
    isPinCheckFailed: boolean;
}

const PinGuideTextArea = ({isPinCheckFailed}: IProps) => {
    const navigate = useNavigate();

    const onClickResetPin = () => {
        navigate('/setting', { 
            state: { 
                viewType: ViewModel.SettingViewType.PIN_SETTING 
            }
        });
    };

    return (
        <div className="txt-area">
            <p className="body-s-n fw-b">{isPinCheckFailed ? INPUT_MSG.PIN_CHECK_FAILED : ''}</p>
            <span 
                className="setting_pin_text" 
                onClick={onClickResetPin}
                style={{ cursor: 'pointer' }}
            >
                PIN 비밀번호 재설정
            </span>
        </div>
    )
}

export default PinGuideTextArea;